import { render, staticRenderFns } from "./authForm.vue?vue&type=template&id=1f49e304"
import script from "./authForm.vue?vue&type=script&lang=js"
export * from "./authForm.vue?vue&type=script&lang=js"
import style0 from "./authForm.vue?vue&type=style&index=0&id=1f49e304&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports